import PropTypes from "prop-types";
import { Card as BSCard } from "react-bootstrap";

import { CardContainer } from "./Card.styles";

export const Card = ({ title, description, children, ...props }) => {
  return (
    <CardContainer {...props}>
      <BSCard.Body>
        {title && <BSCard.Title>{title}</BSCard.Title>}
        {description && <BSCard.Text>{description}</BSCard.Text>}
        {children}
      </BSCard.Body>
    </CardContainer>
  );
};

Card.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
};
